"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initChartPlugins = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var autohideLabels_1 = tslib_1.__importDefault(require("./plugins/autohideLabels/autohideLabels"));
var dataLabelsColors_1 = require("./plugins/dataLabelsColors");
var pointHalo_1 = require("./plugins/pointHalo");
var linearTickPositions_1 = require("./plugins/linearTickPositions");
var group_categories_wrapper_1 = require("./plugins/group-categories-wrapper");
var renderBubbles_1 = require("./plugins/renderBubbles");
var adjustTickAmount_1 = require("./plugins/adjustTickAmount");
var grouped_categories_1 = require("./plugins/3rdParty/grouped-categories");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function initChartPlugins(Highcharts) {
    autohideLabels_1.default(Highcharts);
    dataLabelsColors_1.extendDataLabelColors(Highcharts);
    pointHalo_1.applyPointHaloOptions(Highcharts);
    linearTickPositions_1.linearTickPositions(Highcharts);
    grouped_categories_1.groupedCategories(Highcharts);
    group_categories_wrapper_1.groupCategoriesWrapper(Highcharts);
    adjustTickAmount_1.adjustTickAmount(Highcharts);
    // modify rendering bubbles in bubble chart after upgrade to Highcharts v7.1.1
    renderBubbles_1.renderBubbles(Highcharts);
}
exports.initChartPlugins = initChartPlugins;
//# sourceMappingURL=chartPlugins.js.map